import { render, staticRenderFns } from "./ReportTwo.vue?vue&type=template&id=e6a4fcfc"
import script from "./ReportTwo.vue?vue&type=script&lang=js"
export * from "./ReportTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports